/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
/*global Slick */
//  used by exhibitor sales login and sales window ( Rent booth and Hold booth)

expocadfx.CompanyList = function( div, label) {
	'use strict';
    var FxEvent = expocadfx.fxevent;
	var comparer = expocadfx.comparer;
    var dataview = new Slick.Data.DataView( {inlineFilters: false});
	
    
    var Grid = Slick.Grid;
	
    var doc = document;
    var gridCompanies = null;
      
    var divGrid = div;
    var arCompanies = [];
    var searchString = "";
    var searchField = doc.getElementById( "cSrch");
    
    var columns = [
            {id: "companyLabel", name: label, field: "name", cssClass: "cell-text" }
        ];
    var options = {
        enableCellNavigation: true,
        enableColumnReorder: false,
        forceFitColumns: true,
        rowHeight: 24
    };
    
    function updateFilter() {
        dataview.setFilterArgs( { searchString: searchString});
        dataview.refresh();
        gridCompanies.invalidate();
    }
    
    function basicFilter( item, args) {
        if (args.searchString !== "" && 
            (item.name.toLowerCase().indexOf(args.searchString.toLowerCase()) === -1 )) {
            return false;
        }
        else {
            return true;
        }
    }
    
    function gridClickHandler( evt) {
        var cell = gridCompanies.getCellFromEvent( evt);
        var id = dataview.getItem( cell.row).exhibitorId;
        var name = dataview.getItem( cell.row).name;
       
        doc.dispatchEvent( new FxEvent( "Company_Grid_Click", { "companyId":id, "companyName":name }));
    }

    function createCompanyGrid() {
        gridCompanies = new Grid( divGrid, dataview, columns, options);
        gridCompanies.setSelectionModel(new Slick.RowSelectionModel());
          
        gridCompanies.onClick.subscribe( function( evt) {
            gridClickHandler( evt);
        });
    }
    
    function setCompanies( value) {
        var i;
        var len = value.length;

        for( i = 0; i < len; i++) {
            arCompanies.push( { 
                id:i,
                bLocal:false,
                name: value[i].ExhibitorName, 
                exhibitorId:value[i].ExhibitorId});
        }

        dataview.beginUpdate();
        dataview.setItems( arCompanies);
        dataview.setFilterArgs( { searchString: searchString});
        dataview.setFilter( basicFilter);
        dataview.endUpdate();
		
        dataview.sort( comparer( "name", true), true);

        createCompanyGrid();
    }

    if( searchField !== null) {
        searchField.addEventListener( "input", function () {
            searchString = searchField.value;
            updateFilter();
        });
    }
    
    return {
        setCompanies: setCompanies
    };
};